export const TOGGLE_MODE = "TOGGLE_MODE";
export const SETTINGS = "SETTINGS";
export const USER_INFO = "USER_INFO";
export const USER_BINANCE_ACCOUNT_INFO = "USER_BINANCE_ACCOUNT_INFO";
export const GET_CURRENCY_CONFIG = "GET_CURRENCY_CONFIG";
export const CHANGE_CURRENCY = "CHANGE_CURRENCY";
export const CHANGE_SIDE = "CHANGE_SIDE";
export const CHANGE_APPROACH = "CHANGE_APPROACH";
export const CHANGE_METHOD = "CHANGE_METHOD";
export const UPDATE_WALLET_CONFIG = "UPDATE_WALLET_CONFIG";
export const GET_CHARTS_SETTINGS = "GET_CHARTS_SETTINGS";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const TOGGLE_RENKO_STATUS = "TOGGLE_RENKO_STATUS";
export const TOGGLE_MODEL_STATUS = "TOGGLE_MODEL_STATUS";
export const TOGGLE_BINANCE_STATUS = "TOGGLE_BINANCE_STATUS";
export const GET_TRANSACTIONS_DETAILS = "GET_TRANSACTIONS_DETAILS";
export const GET_MODEL_TOTAL_STATUS = "GET_MODEL_TOTAL_STATUS";
export const GET_ENTRY_PRICE = "GET_ENTRY_PRICE";
export const GET_MARKET_PRICE = "GET_MARKET_PRICE";
export const EXIT_MAKET = "EXIT_MAKET";
export const GET_RENKO_DATA = "GET_RENKO_DATA";
export const TOGGLE_SPINNER_STATE = "TOGGLE_SPINNER_STATE";
export const TOGGLE_TRANSACTIONS_SPINNER_STATE = "TOGGLE_TRANSACTIONS_SPINNER_STATE";
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
